import {useEffect, useRef, useState} from 'react';

export const useStickyOffset = () => {
    const stickyElementRef = useRef(null);
    const [offsetTop, setOffsetTop] = useState(0);

    useEffect(() => {
        if (!stickyElementRef.current) return;

        const update = () => {
            const height = stickyElementRef.current?.offsetHeight || 0;
            setOffsetTop(height);
        };

        update();

        const resizeObserver = new ResizeObserver(update);
        resizeObserver.observe(stickyElementRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return {stickyElementRef, offsetTop};
};
